import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, X } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function ImpersonationBanner() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  if (!user || !user.impersonator) return null;

  async function stop() {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/stop-impersonation");
      if (data?.user) {
        setUser(data.user);
        navigate("/admin", { replace: true });
      } else {
        setUser(false);
        navigate("/login", { replace: true });
      }
    } catch (e) {
      console.error("Stop impersonation failed", e);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      className="sticky top-0 z-[60] w-full px-4 py-2.5 flex items-center justify-center gap-3 text-[13px] shadow-sm"
      style={{ background: "#fef3c7", color: "#78350f", borderBottom: "1px solid #fcd34d" }}
      data-testid="impersonation-banner"
    >
      <ShieldAlert size={15} className="shrink-0" />
      <div className="leading-tight">
        <strong>Impersonating</strong> {user.email}
        <span className="opacity-70"> · as {user.impersonator.email}</span>
      </div>
      <button
        onClick={stop}
        disabled={busy}
        className="inline-flex items-center gap-1 font-semibold underline underline-offset-2 hover:opacity-80 disabled:opacity-50"
        data-testid="impersonation-stop-btn"
      >
        {busy ? "Stopping…" : (<><X size={13} /> Stop impersonating</>)}
      </button>
    </div>
  );
}
